import { create } from 'zustand'
import { IQueryOption } from './type'

type QueryOptionType = IQueryOption
const STORE_INIT_VALUE: QueryOptionType = {
  pageNumber: 1,
  searchKeyWords: '',
}
export const useStore = create(() => ({
  ...STORE_INIT_VALUE
}))

export const setSearchKeyWords: (searchKeyWords: string) => void = (searchKeyWords) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({
      searchKeyWords,
      pageNumber: 1,
    })
  })
}
export const setSort: (sort: string) => void = (sort) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ sort })
  })
}
export const setPageNumber: (pageNumber: number) => void = (pageNumber) => {
  useStore.setState((/*state:QueryOptionType*/) => {
    return ({ pageNumber })
  })
}
